import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'alarmSeverity' })
export class AlarmSeverityPipe implements PipeTransform {

  readonly severityMap = {
    0: 'Clear',
    1: 'Indeterminate',
    2: 'Warning',
    3: 'Minor',
    4: 'Major',
    5: 'Critical'
  };

  transform(severityId: number): any {
    return this.severityMap[severityId];
  }
}
